import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  padding: 0 0 10px;
`;

export const EmailNote = styled.div`
  width: 100%;
  background-color: #f5f6f7;
  padding: 10px;
`;

export const UserRole = styled.div`
  position: relative;
`;

export const Box = styled.div`
  //margin-top: 15px;
  width: 100%;
  position: relative;
  //padding-bottom: 20px;
`;
